export const routes = [
  {
    key: 1,
    route: "/",
    text: "Dashboard",
    icon: "flaticon2-architecture-and-city",
  },
  {
    key: 2,
    route: "/product",
    text: "Products",
    icon: "flaticon2-delivery-truck",
  },
  {
    key: 3,
    route: "/order",
    text: "Orders",
    icon: "flaticon2-list-2",
  },
  {
    key: 4,
    route: "/expiringlots",
    text: "Expiring Lots",
    icon: "flaticon2-delivery-truck",
  },
  {
    key: 5,
    route: "/location",
    text: "Locations",
    icon: "flaticon2-delivery-truck",
  },
  {
    key: 6,
    route: "/notifications",
    text: "Notifications",
    icon: "flaticon2-bell-4",
  },
  {
    key: 7,
    route: "/contact",
    text: "Contact",
    icon: "flaticon2-mail",
  },
];
